/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/user/action/userActionTypes';

import type { State } from 'src/shared/core/type/reduxTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isFetching: false,
  result: [],
  count: null,
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const handleRequest = (state: State) => ({
  ...state,
  isFetching: true,
  result: [],
  count: null,
});

const handleSuccess = (state: State, { result, count }: Object) => ({
  ...state,
  isFetching: false,
  result, // Ignore pages for now
  count,
});

const reset = (state: State) => ({
  ...state,
  isFetching: false,
  result: [],
  count: null,
});

export default createReducer(initialState, {
  [types.FETCH_USERS_REQUEST]: handleRequest,
  [types.FETCH_USERS_SUCCESS]: handleSuccess,
  [types.FETCH_USERS_FAILURE]: reset,
  [types.RESET_USERS]: reset,
});
